<template>
  <div id="app">
    <div class="header">
      <div class="web clearfix">
        <h1 class="logo fl">
          <router-link to="/">
            <img :src= "baseApi + 'webimages/logo.png'">
          </router-link>
        </h1>
        <div class="rightnav fr clearfix">
<!--          <div class="header-crumbs clearfix fr">-->
<!--            <div class="weixin fr bdsharebuttonbox ">-->
<!--              <a href="#" class="bds_weixin shearweixin" data-cmd="weixin" title="分享到微信"></a>-->
<!--            </div>-->
<!--            <div class="search-box celarfix fr">-->
<!--              <form id="topSearch">-->
<!--                <label class="clearfix">-->
<!--                  <input class="text" type="text" id="txtTopKeys" placeholder="搜索"></label>-->
<!--                <input class="submit" type="submit" value="">-->
<!--              </form>-->
<!--            </div>-->
<!--          </div>-->
          <ul class="nav clearfix">
            <li>
              <router-link  :class="curIndex === 0 ? 'cur' : ''"  to="/">首页</router-link>
            </li>
            <li v-for="(p,index) in menus" :key="index">
              <router-link :class="curIndex === index + 1 ? 'cur' : ''" :to="p.src">{{p.name}}</router-link>
              <div class="subnav" style="display: none;">
                <div class="container other">
                  <div class="row" style="width: 154px">
                    <router-link v-for="(c,i) in p.children" :key="i" :to="c.src">{{c.name}}</router-link>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <router-view/>
    <div class="footer clearfix">
      <div class="web">
        <div class="foot-nr clearfix">
          <ul class="clearfix fl">
            <li v-for="(p, index) in menus" :key="index">
              <h5>{{p.name}}</h5>
              <p> <router-link v-for="(c,i) in p.children" :key="i" :to="c.src">{{c.name}}</router-link></p>
            </li>
          </ul>
          <div class="code fr">
            <p class="footphone01 clearfix">
              <img :src="baseApi + 'webimages/tel.png'">13805601452
            </p>
            <p class="footphone01 clearfix">
<!--              <img :src="baseApi + 'webimages/meil.png'">marketing@wa-cheer.com-->
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix bottominfo">
      <div class="web clearfix">
        <div class="fl">
          <router-link to="/contact">  联系我们  </router-link>
          <em>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</em><router-link to="/webmap">网站地图</router-link>
          <em>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</em><router-link to="/law">法律声明</router-link>
        </div>
        <span class="fl beiah">© 2024  合肥信悦信息科技有限公司 | <a href="http://www.beian.gov.cn/" target="_blank">皖ICP备2024038414号</a>
<!--        <span class="fl beiah">© 2024  合肥信悦信息科技有限公司 | <a href="http://www.beian.gov.cn/" target="_blank">皖ICP备2020124927号</a>-->
          <!-- <a href="./index.html" target="_blank"><img src="./webimages/icon7.png" /></a></span> -->
    </span></div>
    </div>
    <div class="rightmenu">
      <div class="ico04 ico-box" style="display: block;"></div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'App',
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/',
      menus: [],
      curIndex: 0
    }
  },
  watch: {
    $route (to, from) {
      this.curIndex = parseInt(to.name.split('-')[0])
    }
  },
  mounted () {
    axios({
      method: 'get',
      url: process.env.API_ROOT + 'static/menu.json'
    })
      .then(response => {
        console.log(response)
        this.menus = response.data
      }).catch(reason => {
        console.log(reason)
      })
    const _this = this
    window.$('#topSearch').submit(function () {
      _this.$router.push({ path: '/search' })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue